export const aiBusinessProblems = [
  {
    id: "lead-generation",
    label: "Best AI for Lead Generation",
    description: "Tools that help you find prospects, personalize outreach, and turn conversations into qualified leads.",
  },
  {
    id: "customer-support",
    label: "Best AI for Customer Support",
    description: "AI that answers tickets faster, drafts replies, and helps teams resolve issues with consistency.",
  },
  {
    id: "automation",
    label: "Best AI for Automation",
    description: "AI that helps automate repetitive workflows, create SOPs, and connect tools to get work done with less manual effort.",
  },
  {
    id: "content-marketing",
    label: "Best AI for Content Marketing",
    description: "AI for blog posts, landing pages, SEO briefs, repurposing, and editorial workflows.",
  },
  {
    id: "seo",
    label: "Best AI for SEO",
    description: "AI for keyword research, content briefs, on-page improvements, metadata, internal linking, and SEO-driven content production.",
  },
  {
    id: "ads",
    label: "Best AI for Ads",
    description: "AI for ad copy, creative variations, targeting ideas, landing page alignment, and campaign iteration.",
  },
  {
    id: "email-marketing",
    label: "Best AI for Email Marketing",
    description: "AI to write newsletters, lifecycle sequences, segmentation messaging, and improve conversions with better copy and testing.",
  },
  {
    id: "bookkeeping",
    label: "Best AI for Bookkeeping",
    description: "AI to help categorize transactions, summarize financials, draft reports, and reduce time spent on bookkeeping tasks.",
  },
  {
    id: "sales",
    label: "Best AI for Sales",
    description: "AI for prospecting, discovery, proposals, follow-ups, and CRM-style workflows that keep deals moving.",
  },
  {
    id: "marketing",
    label: "Best AI for Marketing",
    description: "AI for go-to-market planning, messaging, campaigns, and cross-channel execution.",
  },
  {
    id: "sales-enablement",
    label: "Best AI for Sales Enablement",
    description: "AI that helps reps write emails, build proposals, summarize calls, and keep follow-ups tight.",
  },
];

export const aiProblemRankings = {
  "lead-generation": [
    {
      name: "ChatGPT",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://chat.openai.com",
      rating: 4.6,
      reviewCount: 5000,
      fitScore: 9.1,
      why: "Great for writing personalized outbound messages, building ICPs, and creating outreach sequences fast.",
    },
    {
      name: "Claude",
      category: "AI Assistant",
      pricing: "Paid",
      website: "https://claude.ai",
      rating: 4.6,
      reviewCount: 1600,
      fitScore: 8.7,
      why: "Strong for long-form personalization, account research summaries, and draft refinement.",
    },
    {
      name: "Zolaid",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://zolaid.com",
      rating: 4.8,
      reviewCount: 1200,
      fitScore: 8.3,
      why: "Good for building sales assets, landing pages, and workflows that connect messaging to conversion.",
    },
  ],
  "customer-support": [
    {
      name: "ChatGPT",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://chat.openai.com",
      rating: 4.6,
      reviewCount: 5000,
      fitScore: 8.9,
      why: "Fast drafting for ticket replies, macros, and knowledge base articles when paired with your support docs.",
    },
    {
      name: "Claude",
      category: "AI Assistant",
      pricing: "Paid",
      website: "https://claude.ai",
      rating: 4.6,
      reviewCount: 1600,
      fitScore: 8.6,
      why: "Great at maintaining tone, handling long context, and producing consistent, policy-aligned responses.",
    },
    {
      name: "Zolaid",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://zolaid.com",
      rating: 4.8,
      reviewCount: 1200,
      fitScore: 8.1,
      why: "Useful for internal workflows, SOPs, and automations that support support teams across tools.",
    },
  ],
  "automation": [
    {
      name: "Zolaid",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://zolaid.com",
      rating: 4.8,
      reviewCount: 1200,
      fitScore: 8.8,
      why: "Good for turning tasks into repeatable workflows and building assets (docs/pages) that support automation projects.",
    },
    {
      name: "ChatGPT",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://chat.openai.com",
      rating: 4.6,
      reviewCount: 5000,
      fitScore: 8.5,
      why: "Great for drafting SOPs, generating scripts, and iterating on workflow logic quickly.",
    },
    {
      name: "Claude",
      category: "AI Assistant",
      pricing: "Paid",
      website: "https://claude.ai",
      rating: 4.6,
      reviewCount: 1600,
      fitScore: 8.2,
      why: "Strong for long-form process documentation and careful step-by-step automation plans.",
    },
  ],
  "content-marketing": [
    {
      name: "ChatGPT",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://chat.openai.com",
      rating: 4.6,
      reviewCount: 5000,
      fitScore: 9.0,
      why: "Great for outlines, drafts, hooks, repurposing, and quick iteration on positioning and tone.",
    },
    {
      name: "Claude",
      category: "AI Assistant",
      pricing: "Paid",
      website: "https://claude.ai",
      rating: 4.6,
      reviewCount: 1600,
      fitScore: 8.8,
      why: "Excellent for longer editorial workflows and polishing, especially with style constraints.",
    },
    {
      name: "Zolaid",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://zolaid.com",
      rating: 4.8,
      reviewCount: 1200,
      fitScore: 8.2,
      why: "Helps turn content into assets (pages, creatives, workflows) and organize multi-format production.",
    },
  ],
  "seo": [
    {
      name: "ChatGPT",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://chat.openai.com",
      rating: 4.6,
      reviewCount: 5000,
      fitScore: 8.9,
      why: "Good for keyword clustering, writing briefs, metadata drafts, and SEO-friendly outlines fast.",
    },
    {
      name: "Claude",
      category: "AI Assistant",
      pricing: "Paid",
      website: "https://claude.ai",
      rating: 4.6,
      reviewCount: 1600,
      fitScore: 8.6,
      why: "Strong for longer content, editorial polish, and maintaining consistent style across SEO pages.",
    },
    {
      name: "Zolaid",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://zolaid.com",
      rating: 4.8,
      reviewCount: 1200,
      fitScore: 8.2,
      why: "Useful for creating SEO landing pages and organizing assets/workflows around content production.",
    },
  ],
  "ads": [
    {
      name: "ChatGPT",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://chat.openai.com",
      rating: 4.6,
      reviewCount: 5000,
      fitScore: 8.9,
      why: "Great for ad copy variations, hooks, angles, and rapid iteration on messaging.",
    },
    {
      name: "Claude",
      category: "AI Assistant",
      pricing: "Paid",
      website: "https://claude.ai",
      rating: 4.6,
      reviewCount: 1600,
      fitScore: 8.5,
      why: "Strong for more nuanced brand voice and longer-form landing page alignment with ad intent.",
    },
    {
      name: "Zolaid",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://zolaid.com",
      rating: 4.8,
      reviewCount: 1200,
      fitScore: 8.2,
      why: "Useful when you want to turn ads into full funnels (landing pages + assets) and keep campaign assets organized.",
    },
  ],
  "email-marketing": [
    {
      name: "ChatGPT",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://chat.openai.com",
      rating: 4.6,
      reviewCount: 5000,
      fitScore: 8.9,
      why: "Great for lifecycle sequences, newsletters, subject line testing, and segmentation-specific copy.",
    },
    {
      name: "Claude",
      category: "AI Assistant",
      pricing: "Paid",
      website: "https://claude.ai",
      rating: 4.6,
      reviewCount: 1600,
      fitScore: 8.6,
      why: "Strong for consistent tone across long sequences and for editing/refining conversion-focused copy.",
    },
    {
      name: "Zolaid",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://zolaid.com",
      rating: 4.8,
      reviewCount: 1200,
      fitScore: 8.1,
      why: "Useful for producing email + landing page assets together and managing campaign content workflows.",
    },
  ],
  "bookkeeping": [
    {
      name: "ChatGPT",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://chat.openai.com",
      rating: 4.6,
      reviewCount: 5000,
      fitScore: 8.3,
      why: "Good for explaining transactions, drafting summaries, and creating bookkeeping SOPs (not a replacement for accounting software).",
    },
    {
      name: "Claude",
      category: "AI Assistant",
      pricing: "Paid",
      website: "https://claude.ai",
      rating: 4.6,
      reviewCount: 1600,
      fitScore: 8.1,
      why: "Strong for careful summarization and longer financial narratives when you provide structured inputs.",
    },
    {
      name: "Zolaid",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://zolaid.com",
      rating: 4.8,
      reviewCount: 1200,
      fitScore: 7.8,
      why: "Useful for workflow automation around finance operations and generating internal docs/checklists.",
    },
  ],
  "sales": [
    {
      name: "ChatGPT",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://chat.openai.com",
      rating: 4.6,
      reviewCount: 5000,
      fitScore: 9.0,
      why: "Strong for cold emails, discovery questions, proposals, objection handling, and follow-ups.",
    },
    {
      name: "Claude",
      category: "AI Assistant",
      pricing: "Paid",
      website: "https://claude.ai",
      rating: 4.6,
      reviewCount: 1600,
      fitScore: 8.7,
      why: "Great for longer customer-specific docs, account summaries, and consistent messaging frameworks.",
    },
    {
      name: "Zolaid",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://zolaid.com",
      rating: 4.8,
      reviewCount: 1200,
      fitScore: 8.3,
      why: "Useful for turning sales messaging into assets (landing pages, docs) and building repeatable workflows.",
    },
  ],
  "marketing": [
    {
      name: "ChatGPT",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://chat.openai.com",
      rating: 4.6,
      reviewCount: 5000,
      fitScore: 8.8,
      why: "Great for GTM planning, messaging, campaign ideas, and rapid copy iteration across channels.",
    },
    {
      name: "Claude",
      category: "AI Assistant",
      pricing: "Paid",
      website: "https://claude.ai",
      rating: 4.6,
      reviewCount: 1600,
      fitScore: 8.5,
      why: "Strong for brand voice consistency and longer strategic docs, especially with detailed constraints.",
    },
    {
      name: "Zolaid",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://zolaid.com",
      rating: 4.8,
      reviewCount: 1200,
      fitScore: 8.2,
      why: "Useful for turning marketing plans into assets and organizing multi-format production workflows.",
    },
  ],
  "sales-enablement": [
    {
      name: "ChatGPT",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://chat.openai.com",
      rating: 4.6,
      reviewCount: 5000,
      fitScore: 9.0,
      why: "Strong for proposals, discovery questions, objection handling scripts, and follow-up sequences.",
    },
    {
      name: "Claude",
      category: "AI Assistant",
      pricing: "Paid",
      website: "https://claude.ai",
      rating: 4.6,
      reviewCount: 1600,
      fitScore: 8.7,
      why: "Great for consistent messaging frameworks and longer customer-specific documents.",
    },
    {
      name: "Zolaid",
      category: "AI Assistant",
      pricing: "Freemium",
      website: "https://zolaid.com",
      rating: 4.8,
      reviewCount: 1200,
      fitScore: 8.3,
      why: "Useful for bundling messaging, demos, and landing pages into a cohesive enablement workflow.",
    },
  ],
};
